import { render, staticRenderFns } from "./BannerConsultants.vue?vue&type=template&id=34385030&scoped=true"
import script from "./BannerConsultants.vue?vue&type=script&lang=js"
export * from "./BannerConsultants.vue?vue&type=script&lang=js"
import style0 from "./BannerConsultants.vue?vue&type=style&index=0&id=34385030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34385030",
  null
  
)

export default component.exports